export default __webpack_public_path__ + "static/media/macys.073ec058.png";